module.exports = __webpack_public_path__ + "img/crm.1118929d.svg";